/**
 * Generated by orval v7.17.0 🍺
 * Do not edit manually.
 * FieldPay API
 * FieldPay API for managing organizations, opportunities, payouts and talent management
 * OpenAPI spec version: v1
 */
import * as zod from 'zod';


/**
 * **Required Permission(s):** ORG_PAYOUT_REQUEST_LIST
 */
export const listPayoutRequestsQueryPageDefault = 1;export const listPayoutRequestsQueryPageSizeDefault = 25;export const listPayoutRequestsQuerySortDescendingDefault = true;export const listPayoutRequestsQueryLatestPerClaimDefault = false;

export const listPayoutRequestsQueryParams = zod.object({
  "page": zod.number().default(listPayoutRequestsQueryPageDefault),
  "pageSize": zod.number().default(listPayoutRequestsQueryPageSizeDefault),
  "statuses": zod.array(zod.enum(['Pending', 'Returned', 'Denied', 'Approved'])).optional(),
  "startDate": zod.string().datetime({}).optional(),
  "endDate": zod.string().datetime({}).optional(),
  "search": zod.string().optional(),
  "sortBy": zod.string().optional(),
  "sortDescending": zod.boolean().default(listPayoutRequestsQuerySortDescendingDefault),
  "latestPerClaim": zod.boolean().optional()
})

export const listPayoutRequestsResponseItemsItemSourceAddressAddressLine1Max = 255;

export const listPayoutRequestsResponseItemsItemSourceAddressAddressLine2Max = 255;

export const listPayoutRequestsResponseItemsItemSourceAddressCityMax = 255;

export const listPayoutRequestsResponseItemsItemSourceAddressStateMax = 2;

export const listPayoutRequestsResponseItemsItemSourceAddressZipMax = 10;

export const listPayoutRequestsResponseItemsItemSourceAddressCountryMax = 100;



export const listPayoutRequestsResponse = zod.object({
  "items": zod.array(zod.object({
  "payoutRequest": zod.object({
  "id": zod.string().uuid(),
  "payeeName": zod.string(),
  "amount": zod.number().nullish(),
  "status": zod.enum(['Pending', 'Returned', 'Denied', 'Approved']),
  "createdDate": zod.string().datetime({}),
  "concurrencyToken": zod.string(),
  "payoutSetupStatus": zod.enum(['OrganizationRelationshipNeeded', 'NotStarted', 'IdentityVerificationPending', 'PayoutMethodNeeded', 'BankAccountAwaitingReview', 'BankAccountRejected', 'BankAccountUnlinked', 'BankAccountReturned', 'DebitCardNotPayoutEligible', 'DebitCardPayoutsUnavailable', 'Ready']),
  "isPaymentEligible": zod.boolean(),
  "hasApprovedNonPrimaryBankAccount": zod.boolean(),
  "invoice": zod.object({
  "id": zod.string().uuid(),
  "number": zod.number(),
  "status": zod.enum(['Draft', 'Finalized', 'Paid', 'Voided'])
}).optional()
}),
  "source": zod.object({
  "workflow": zod.enum(['Opportunity', 'FsmGenerated', 'TalentMemberGenerated', 'StaffMemberGenerated']),
  "address": zod.object({
  "addressLine1": zod.string().max(listPayoutRequestsResponseItemsItemSourceAddressAddressLine1Max).nullish(),
  "addressLine2": zod.string().max(listPayoutRequestsResponseItemsItemSourceAddressAddressLine2Max).nullish(),
  "city": zod.string().max(listPayoutRequestsResponseItemsItemSourceAddressCityMax).nullish(),
  "state": zod.string().max(listPayoutRequestsResponseItemsItemSourceAddressStateMax).nullish(),
  "zip": zod.string().max(listPayoutRequestsResponseItemsItemSourceAddressZipMax).nullish(),
  "country": zod.string().max(listPayoutRequestsResponseItemsItemSourceAddressCountryMax).nullish(),
  "googlePlaceId": zod.string().nullish(),
  "latitude": zod.number().nullish(),
  "longitude": zod.number().nullish(),
  "geocodeFailed": zod.boolean().nullish()
}).optional(),
  "opportunityClaim": zod.object({
  "opportunityClaimId": zod.string().uuid(),
  "opportunityTitle": zod.string()
}).optional(),
  "fsmCompletedWork": zod.object({
  "fsmCompletedWorkId": zod.string().uuid(),
  "description": zod.string().nullish(),
  "notes": zod.string().nullish(),
  "customerName": zod.string().nullish(),
  "sourceReference": zod.string().nullish(),
  "platform": zod.enum(['ColdStandard', 'HousecallPro', 'PoolBrain', 'ServiceTitan', 'Skimmer']),
  "referenceType": zod.enum(['Invoice', 'RouteStop', 'WorkOrder', 'Visit', 'Reimbursement'])
}).optional(),
  "reimbursement": zod.object({
  "description": zod.string().nullish()
}).optional()
}),
  "fsmGrouping": zod.object({
  "fsmCompletedWorkId": zod.string().uuid(),
  "allocationConfirmed": zod.boolean()
}).optional(),
  "payout": zod.object({
  "id": zod.string().uuid(),
  "payee": zod.object({
  "type": zod.enum(['User', 'Organization']),
  "id": zod.string().uuid()
}),
  "amount": zod.number(),
  "amountOwed": zod.number(),
  "disbursementTiming": zod.enum(['Standard', 'Early']),
  "currency": zod.string(),
  "status": zod.string(),
  "releaseDate": zod.string().datetime({}).nullish(),
  "createdDate": zod.string().datetime({}),
  "payeeName": zod.string().nullish(),
  "internalMemo": zod.string().nullish(),
  "payeeMemo": zod.string().nullish(),
  "overdueSince": zod.string().datetime({}).nullish(),
  "payoutRequestCount": zod.number()
}).optional()
})),
  "totalCount": zod.number(),
  "page": zod.number(),
  "pageSize": zod.number(),
  "totalPages": zod.number(),
  "hasNextPage": zod.boolean(),
  "hasPreviousPage": zod.boolean()
})

/**
 * **Required Permission(s):** ORG_PAYOUT_REQUEST_LIST
 */
export const getPayoutRequestStatsResponse = zod.object({
  "all": zod.number(),
  "pending": zod.number(),
  "returned": zod.number(),
  "denied": zod.number(),
  "approved": zod.number()
})

/**
 * **Required Permission(s):** ORG_PAYOUT_REQUEST_GET
 */
export const getPayoutRequestByIdParams = zod.object({
  "id": zod.string().uuid()
})

export const getPayoutRequestByIdResponse = zod.object({
  "id": zod.string().uuid(),
  "organizationId": zod.string().uuid(),
  "payee": zod.object({
  "type": zod.enum(['User', 'Organization']),
  "id": zod.string().uuid()
}),
  "payeeName": zod.string(),
  "quantity": zod.number(),
  "amount": zod.number().nullish(),
  "status": zod.enum(['Pending', 'Returned', 'Denied', 'Approved']),
  "workflow": zod.enum(['Opportunity', 'FsmGenerated', 'TalentMemberGenerated', 'StaffMemberGenerated']),
  "canBeReturned": zod.boolean(),
  "payoutSetupStatus": zod.enum(['OrganizationRelationshipNeeded', 'NotStarted', 'IdentityVerificationPending', 'PayoutMethodNeeded', 'BankAccountAwaitingReview', 'BankAccountRejected', 'BankAccountUnlinked', 'BankAccountReturned', 'DebitCardNotPayoutEligible', 'DebitCardPayoutsUnavailable', 'Ready']),
  "isPaymentEligible": zod.boolean(),
  "hasApprovedNonPrimaryBankAccount": zod.boolean(),
  "reviewedByUserId": zod.string().uuid().nullish(),
  "reviewerName": zod.string().nullish(),
  "reviewedDate": zod.string().datetime({}).nullish(),
  "reviewNotes": zod.string().nullish(),
  "approvalMethod": zod.enum(['Administrator', 'PreApproved', 'AutoApproved']).optional(),
  "evidence": zod.object({
  "id": zod.string().uuid(),
  "payoutRequestId": zod.string().uuid(),
  "text": zod.string().nullish(),
  "documents": zod.array(zod.object({
  "id": zod.string().uuid(),
  "blobUrlId": zod.string().uuid(),
  "url": zod.string(),
  "hash": zod.string(),
  "contentType": zod.string().nullish(),
  "fileSize": zod.number().nullish(),
  "createdDate": zod.string().datetime({})
})),
  "references": zod.array(zod.object({
  "id": zod.string().uuid(),
  "label": zod.string(),
  "referenceValue": zod.string(),
  "createdDate": zod.string().datetime({})
})),
  "gpsCheckins": zod.array(zod.object({
  "id": zod.string().uuid(),
  "gpsCoordinateId": zod.string().uuid(),
  "latitude": zod.number().nullish(),
  "longitude": zod.number().nullish(),
  "accuracy": zod.number().nullish(),
  "note": zod.string().nullish(),
  "createdDate": zod.string().datetime({})
})),
  "createdDate": zod.string().datetime({}),
  "createdByUserId": zod.string().uuid().nullish()
}).optional(),
  "invoice": zod.object({
  "id": zod.string().uuid(),
  "number": zod.number(),
  "status": zod.enum(['Draft', 'Finalized', 'Paid', 'Voided'])
}).optional(),
  "createdDate": zod.string().datetime({}),
  "modifiedDate": zod.string().datetime({}),
  "createdByUserId": zod.string().uuid().nullish(),
  "modifiedByUserId": zod.string().uuid().nullish(),
  "concurrencyToken": zod.string()
})

/**
 * **Required Permission(s):** ORG_PAYOUT_REQUEST_GET
 */
export const getPayoutRequestSourceParams = zod.object({
  "id": zod.string().uuid()
})

export const getPayoutRequestSourceResponseAddressAddressLine1Max = 255;

export const getPayoutRequestSourceResponseAddressAddressLine2Max = 255;

export const getPayoutRequestSourceResponseAddressCityMax = 255;

export const getPayoutRequestSourceResponseAddressStateMax = 2;

export const getPayoutRequestSourceResponseAddressZipMax = 10;

export const getPayoutRequestSourceResponseAddressCountryMax = 100;



export const getPayoutRequestSourceResponse = zod.object({
  "workflow": zod.enum(['Opportunity', 'FsmGenerated', 'TalentMemberGenerated', 'StaffMemberGenerated']),
  "address": zod.object({
  "addressLine1": zod.string().max(getPayoutRequestSourceResponseAddressAddressLine1Max).nullish(),
  "addressLine2": zod.string().max(getPayoutRequestSourceResponseAddressAddressLine2Max).nullish(),
  "city": zod.string().max(getPayoutRequestSourceResponseAddressCityMax).nullish(),
  "state": zod.string().max(getPayoutRequestSourceResponseAddressStateMax).nullish(),
  "zip": zod.string().max(getPayoutRequestSourceResponseAddressZipMax).nullish(),
  "country": zod.string().max(getPayoutRequestSourceResponseAddressCountryMax).nullish(),
  "googlePlaceId": zod.string().nullish(),
  "latitude": zod.number().nullish(),
  "longitude": zod.number().nullish(),
  "geocodeFailed": zod.boolean().nullish()
}).optional(),
  "opportunityClaim": zod.object({
  "opportunityClaimId": zod.string().uuid(),
  "opportunityTitle": zod.string()
}).optional(),
  "fsmCompletedWork": zod.object({
  "fsmCompletedWorkId": zod.string().uuid(),
  "description": zod.string().nullish(),
  "notes": zod.string().nullish(),
  "customerName": zod.string().nullish(),
  "sourceReference": zod.string().nullish(),
  "platform": zod.enum(['ColdStandard', 'HousecallPro', 'PoolBrain', 'ServiceTitan', 'Skimmer']),
  "referenceType": zod.enum(['Invoice', 'RouteStop', 'WorkOrder', 'Visit', 'Reimbursement'])
}).optional(),
  "reimbursement": zod.object({
  "description": zod.string().nullish()
}).optional()
})

/**
 * **Required Permission(s):** ORG_PAYOUT_REQUEST_GET
 */
export const getFsmPayoutRequestDetailParams = zod.object({
  "id": zod.string().uuid()
})

export const getFsmPayoutRequestDetailResponseFsmAddressAddressLine1Max = 255;

export const getFsmPayoutRequestDetailResponseFsmAddressAddressLine2Max = 255;

export const getFsmPayoutRequestDetailResponseFsmAddressCityMax = 255;

export const getFsmPayoutRequestDetailResponseFsmAddressStateMax = 2;

export const getFsmPayoutRequestDetailResponseFsmAddressZipMax = 10;

export const getFsmPayoutRequestDetailResponseFsmAddressCountryMax = 100;



export const getFsmPayoutRequestDetailResponse = zod.object({
  "payoutRequest": zod.object({
  "id": zod.string().uuid(),
  "organizationId": zod.string().uuid(),
  "payee": zod.object({
  "type": zod.enum(['User', 'Organization']),
  "id": zod.string().uuid()
}),
  "payeeName": zod.string(),
  "quantity": zod.number(),
  "amount": zod.number().nullish(),
  "status": zod.enum(['Pending', 'Returned', 'Denied', 'Approved']),
  "workflow": zod.enum(['Opportunity', 'FsmGenerated', 'TalentMemberGenerated', 'StaffMemberGenerated']),
  "canBeReturned": zod.boolean(),
  "payoutSetupStatus": zod.enum(['OrganizationRelationshipNeeded', 'NotStarted', 'IdentityVerificationPending', 'PayoutMethodNeeded', 'BankAccountAwaitingReview', 'BankAccountRejected', 'BankAccountUnlinked', 'BankAccountReturned', 'DebitCardNotPayoutEligible', 'DebitCardPayoutsUnavailable', 'Ready']),
  "isPaymentEligible": zod.boolean(),
  "hasApprovedNonPrimaryBankAccount": zod.boolean(),
  "reviewedByUserId": zod.string().uuid().nullish(),
  "reviewerName": zod.string().nullish(),
  "reviewedDate": zod.string().datetime({}).nullish(),
  "reviewNotes": zod.string().nullish(),
  "approvalMethod": zod.enum(['Administrator', 'PreApproved', 'AutoApproved']).optional(),
  "evidence": zod.object({
  "id": zod.string().uuid(),
  "payoutRequestId": zod.string().uuid(),
  "text": zod.string().nullish(),
  "documents": zod.array(zod.object({
  "id": zod.string().uuid(),
  "blobUrlId": zod.string().uuid(),
  "url": zod.string(),
  "hash": zod.string(),
  "contentType": zod.string().nullish(),
  "fileSize": zod.number().nullish(),
  "createdDate": zod.string().datetime({})
})),
  "references": zod.array(zod.object({
  "id": zod.string().uuid(),
  "label": zod.string(),
  "referenceValue": zod.string(),
  "createdDate": zod.string().datetime({})
})),
  "gpsCheckins": zod.array(zod.object({
  "id": zod.string().uuid(),
  "gpsCoordinateId": zod.string().uuid(),
  "latitude": zod.number().nullish(),
  "longitude": zod.number().nullish(),
  "accuracy": zod.number().nullish(),
  "note": zod.string().nullish(),
  "createdDate": zod.string().datetime({})
})),
  "createdDate": zod.string().datetime({}),
  "createdByUserId": zod.string().uuid().nullish()
}).optional(),
  "invoice": zod.object({
  "id": zod.string().uuid(),
  "number": zod.number(),
  "status": zod.enum(['Draft', 'Finalized', 'Paid', 'Voided'])
}).optional(),
  "createdDate": zod.string().datetime({}),
  "modifiedDate": zod.string().datetime({}),
  "createdByUserId": zod.string().uuid().nullish(),
  "modifiedByUserId": zod.string().uuid().nullish(),
  "concurrencyToken": zod.string()
}),
  "fsm": zod.object({
  "platform": zod.enum(['ColdStandard', 'HousecallPro', 'PoolBrain', 'ServiceTitan', 'Skimmer']),
  "referenceType": zod.enum(['Invoice', 'RouteStop', 'WorkOrder', 'Visit', 'Reimbursement']),
  "referenceId": zod.string(),
  "description": zod.string().nullish(),
  "notes": zod.string().nullish(),
  "customerName": zod.string().nullish(),
  "sourceReference": zod.string().nullish(),
  "address": zod.object({
  "addressLine1": zod.string().max(getFsmPayoutRequestDetailResponseFsmAddressAddressLine1Max).nullish(),
  "addressLine2": zod.string().max(getFsmPayoutRequestDetailResponseFsmAddressAddressLine2Max).nullish(),
  "city": zod.string().max(getFsmPayoutRequestDetailResponseFsmAddressCityMax).nullish(),
  "state": zod.string().max(getFsmPayoutRequestDetailResponseFsmAddressStateMax).nullish(),
  "zip": zod.string().max(getFsmPayoutRequestDetailResponseFsmAddressZipMax).nullish(),
  "country": zod.string().max(getFsmPayoutRequestDetailResponseFsmAddressCountryMax).nullish(),
  "googlePlaceId": zod.string().nullish(),
  "latitude": zod.number().nullish(),
  "longitude": zod.number().nullish(),
  "geocodeFailed": zod.boolean().nullish()
}).optional(),
  "itemAmount": zod.number().nullish(),
  "techEmail": zod.string().nullish()
})
})

/**
 * **Required Permission(s):** ORG_PAYOUT_REQUEST_GET
 */
export const getPayoutRequestEvidenceParams = zod.object({
  "id": zod.string().uuid()
})

export const getPayoutRequestEvidenceResponse = zod.object({
  "id": zod.string().uuid(),
  "payoutRequestId": zod.string().uuid(),
  "text": zod.string().nullish(),
  "documents": zod.array(zod.object({
  "id": zod.string().uuid(),
  "blobUrlId": zod.string().uuid(),
  "url": zod.string(),
  "hash": zod.string(),
  "contentType": zod.string().nullish(),
  "fileSize": zod.number().nullish(),
  "createdDate": zod.string().datetime({})
})),
  "references": zod.array(zod.object({
  "id": zod.string().uuid(),
  "label": zod.string(),
  "referenceValue": zod.string(),
  "createdDate": zod.string().datetime({})
})),
  "gpsCheckins": zod.array(zod.object({
  "id": zod.string().uuid(),
  "gpsCoordinateId": zod.string().uuid(),
  "latitude": zod.number().nullish(),
  "longitude": zod.number().nullish(),
  "accuracy": zod.number().nullish(),
  "note": zod.string().nullish(),
  "createdDate": zod.string().datetime({})
})),
  "createdDate": zod.string().datetime({}),
  "createdByUserId": zod.string().uuid().nullish()
})

/**
 * **Required Permission(s):** ORG_PAYOUT_REQUEST_CREATE
 */
export const createPayoutRequestFromOpportunityClaimBodyQuantityMin = 0.01;
export const createPayoutRequestFromOpportunityClaimBodyQuantityMax = 1.7976931348623157e+308;

export const createPayoutRequestFromOpportunityClaimBodyEvidenceTextMax = 4000;

export const createPayoutRequestFromOpportunityClaimBodyEvidenceDocumentsItemUrlMax = 2048;

export const createPayoutRequestFromOpportunityClaimBodyEvidenceDocumentsItemHashMax = 128;

export const createPayoutRequestFromOpportunityClaimBodyEvidenceDocumentsItemContentTypeMax = 255;

export const createPayoutRequestFromOpportunityClaimBodyEvidenceDocumentsItemFileSizeMin = 0;
export const createPayoutRequestFromOpportunityClaimBodyEvidenceDocumentsItemFileSizeMax = 9223372036854776000;

export const createPayoutRequestFromOpportunityClaimBodyEvidenceReferencesItemLabelMax = 100;

export const createPayoutRequestFromOpportunityClaimBodyEvidenceReferencesItemReferenceValueMax = 255;



export const createPayoutRequestFromOpportunityClaimBody = zod.object({
  "opportunityClaimId": zod.string().uuid(),
  "quantity": zod.number().min(createPayoutRequestFromOpportunityClaimBodyQuantityMin).max(createPayoutRequestFromOpportunityClaimBodyQuantityMax),
  "evidence": zod.object({
  "text": zod.string().max(createPayoutRequestFromOpportunityClaimBodyEvidenceTextMax).nullish(),
  "documents": zod.array(zod.object({
  "url": zod.string().min(1).max(createPayoutRequestFromOpportunityClaimBodyEvidenceDocumentsItemUrlMax),
  "hash": zod.string().min(1).max(createPayoutRequestFromOpportunityClaimBodyEvidenceDocumentsItemHashMax),
  "contentType": zod.string().max(createPayoutRequestFromOpportunityClaimBodyEvidenceDocumentsItemContentTypeMax).nullish(),
  "fileSize": zod.number().min(createPayoutRequestFromOpportunityClaimBodyEvidenceDocumentsItemFileSizeMin).max(createPayoutRequestFromOpportunityClaimBodyEvidenceDocumentsItemFileSizeMax).nullish()
})).nullish(),
  "references": zod.array(zod.object({
  "label": zod.string().min(1).max(createPayoutRequestFromOpportunityClaimBodyEvidenceReferencesItemLabelMax),
  "referenceValue": zod.string().min(1).max(createPayoutRequestFromOpportunityClaimBodyEvidenceReferencesItemReferenceValueMax)
})).nullish(),
  "selectedGpsCoordinateIds": zod.array(zod.string().uuid()).nullish()
}).optional()
})

/**
 * **Required Permission(s):** ORG_PAYOUT_REQUEST_CREATE
 */
export const createPayoutRequestFromFsmCompletedWorkBody = zod.object({
  "fsmCompletedWorkId": zod.string().uuid(),
  "payee": zod.object({
  "type": zod.enum(['User', 'Organization']),
  "id": zod.string().uuid()
})
})

/**
 * **Required Permission(s):** ORG_PAYOUT_REQUEST_APPROVE
 */
export const approvePayoutRequestParams = zod.object({
  "id": zod.string().uuid()
})

export const approvePayoutRequestBodyNotesMax = 500;



export const approvePayoutRequestBody = zod.object({
  "notes": zod.string().max(approvePayoutRequestBodyNotesMax).nullish(),
  "concurrencyToken": zod.string()
})

export const approvePayoutRequestResponse = zod.object({
  "id": zod.string().uuid(),
  "organizationId": zod.string().uuid(),
  "payee": zod.object({
  "type": zod.enum(['User', 'Organization']),
  "id": zod.string().uuid()
}),
  "payeeName": zod.string(),
  "quantity": zod.number(),
  "amount": zod.number().nullish(),
  "status": zod.enum(['Pending', 'Returned', 'Denied', 'Approved']),
  "workflow": zod.enum(['Opportunity', 'FsmGenerated', 'TalentMemberGenerated', 'StaffMemberGenerated']),
  "canBeReturned": zod.boolean(),
  "payoutSetupStatus": zod.enum(['OrganizationRelationshipNeeded', 'NotStarted', 'IdentityVerificationPending', 'PayoutMethodNeeded', 'BankAccountAwaitingReview', 'BankAccountRejected', 'BankAccountUnlinked', 'BankAccountReturned', 'DebitCardNotPayoutEligible', 'DebitCardPayoutsUnavailable', 'Ready']),
  "isPaymentEligible": zod.boolean(),
  "hasApprovedNonPrimaryBankAccount": zod.boolean(),
  "reviewedByUserId": zod.string().uuid().nullish(),
  "reviewerName": zod.string().nullish(),
  "reviewedDate": zod.string().datetime({}).nullish(),
  "reviewNotes": zod.string().nullish(),
  "approvalMethod": zod.enum(['Administrator', 'PreApproved', 'AutoApproved']).optional(),
  "evidence": zod.object({
  "id": zod.string().uuid(),
  "payoutRequestId": zod.string().uuid(),
  "text": zod.string().nullish(),
  "documents": zod.array(zod.object({
  "id": zod.string().uuid(),
  "blobUrlId": zod.string().uuid(),
  "url": zod.string(),
  "hash": zod.string(),
  "contentType": zod.string().nullish(),
  "fileSize": zod.number().nullish(),
  "createdDate": zod.string().datetime({})
})),
  "references": zod.array(zod.object({
  "id": zod.string().uuid(),
  "label": zod.string(),
  "referenceValue": zod.string(),
  "createdDate": zod.string().datetime({})
})),
  "gpsCheckins": zod.array(zod.object({
  "id": zod.string().uuid(),
  "gpsCoordinateId": zod.string().uuid(),
  "latitude": zod.number().nullish(),
  "longitude": zod.number().nullish(),
  "accuracy": zod.number().nullish(),
  "note": zod.string().nullish(),
  "createdDate": zod.string().datetime({})
})),
  "createdDate": zod.string().datetime({}),
  "createdByUserId": zod.string().uuid().nullish()
}).optional(),
  "invoice": zod.object({
  "id": zod.string().uuid(),
  "number": zod.number(),
  "status": zod.enum(['Draft', 'Finalized', 'Paid', 'Voided'])
}).optional(),
  "createdDate": zod.string().datetime({}),
  "modifiedDate": zod.string().datetime({}),
  "createdByUserId": zod.string().uuid().nullish(),
  "modifiedByUserId": zod.string().uuid().nullish(),
  "concurrencyToken": zod.string()
})

/**
 * **Required Permission(s):** ORG_PAYOUT_REQUEST_BULK_APPROVE
 */
export const bulkApprovePayoutRequestsBody = zod.object({
  "payoutRequests": zod.array(zod.object({
  "payoutRequestId": zod.string().uuid(),
  "concurrencyToken": zod.string()
})),
  "filterCriteria": zod.string().nullish()
})

/**
 * **Required Permission(s):** ORG_PAYOUT_REQUEST_DENY
 */
export const denyPayoutRequestParams = zod.object({
  "id": zod.string().uuid()
})

export const denyPayoutRequestBodyReasonMax = 500;



export const denyPayoutRequestBody = zod.object({
  "reason": zod.string().min(1).max(denyPayoutRequestBodyReasonMax),
  "concurrencyToken": zod.string()
})

export const denyPayoutRequestResponse = zod.object({
  "id": zod.string().uuid(),
  "organizationId": zod.string().uuid(),
  "payee": zod.object({
  "type": zod.enum(['User', 'Organization']),
  "id": zod.string().uuid()
}),
  "payeeName": zod.string(),
  "quantity": zod.number(),
  "amount": zod.number().nullish(),
  "status": zod.enum(['Pending', 'Returned', 'Denied', 'Approved']),
  "workflow": zod.enum(['Opportunity', 'FsmGenerated', 'TalentMemberGenerated', 'StaffMemberGenerated']),
  "canBeReturned": zod.boolean(),
  "payoutSetupStatus": zod.enum(['OrganizationRelationshipNeeded', 'NotStarted', 'IdentityVerificationPending', 'PayoutMethodNeeded', 'BankAccountAwaitingReview', 'BankAccountRejected', 'BankAccountUnlinked', 'BankAccountReturned', 'DebitCardNotPayoutEligible', 'DebitCardPayoutsUnavailable', 'Ready']),
  "isPaymentEligible": zod.boolean(),
  "hasApprovedNonPrimaryBankAccount": zod.boolean(),
  "reviewedByUserId": zod.string().uuid().nullish(),
  "reviewerName": zod.string().nullish(),
  "reviewedDate": zod.string().datetime({}).nullish(),
  "reviewNotes": zod.string().nullish(),
  "approvalMethod": zod.enum(['Administrator', 'PreApproved', 'AutoApproved']).optional(),
  "evidence": zod.object({
  "id": zod.string().uuid(),
  "payoutRequestId": zod.string().uuid(),
  "text": zod.string().nullish(),
  "documents": zod.array(zod.object({
  "id": zod.string().uuid(),
  "blobUrlId": zod.string().uuid(),
  "url": zod.string(),
  "hash": zod.string(),
  "contentType": zod.string().nullish(),
  "fileSize": zod.number().nullish(),
  "createdDate": zod.string().datetime({})
})),
  "references": zod.array(zod.object({
  "id": zod.string().uuid(),
  "label": zod.string(),
  "referenceValue": zod.string(),
  "createdDate": zod.string().datetime({})
})),
  "gpsCheckins": zod.array(zod.object({
  "id": zod.string().uuid(),
  "gpsCoordinateId": zod.string().uuid(),
  "latitude": zod.number().nullish(),
  "longitude": zod.number().nullish(),
  "accuracy": zod.number().nullish(),
  "note": zod.string().nullish(),
  "createdDate": zod.string().datetime({})
})),
  "createdDate": zod.string().datetime({}),
  "createdByUserId": zod.string().uuid().nullish()
}).optional(),
  "invoice": zod.object({
  "id": zod.string().uuid(),
  "number": zod.number(),
  "status": zod.enum(['Draft', 'Finalized', 'Paid', 'Voided'])
}).optional(),
  "createdDate": zod.string().datetime({}),
  "modifiedDate": zod.string().datetime({}),
  "createdByUserId": zod.string().uuid().nullish(),
  "modifiedByUserId": zod.string().uuid().nullish(),
  "concurrencyToken": zod.string()
})

/**
 * **Required Permission(s):** ORG_PAYOUT_REQUEST_RETURN
 */
export const returnPayoutRequestParams = zod.object({
  "id": zod.string().uuid()
})

export const returnPayoutRequestBodyReasonMax = 500;



export const returnPayoutRequestBody = zod.object({
  "reason": zod.string().min(1).max(returnPayoutRequestBodyReasonMax),
  "concurrencyToken": zod.string()
})

export const returnPayoutRequestResponse = zod.object({
  "id": zod.string().uuid(),
  "organizationId": zod.string().uuid(),
  "payee": zod.object({
  "type": zod.enum(['User', 'Organization']),
  "id": zod.string().uuid()
}),
  "payeeName": zod.string(),
  "quantity": zod.number(),
  "amount": zod.number().nullish(),
  "status": zod.enum(['Pending', 'Returned', 'Denied', 'Approved']),
  "workflow": zod.enum(['Opportunity', 'FsmGenerated', 'TalentMemberGenerated', 'StaffMemberGenerated']),
  "canBeReturned": zod.boolean(),
  "payoutSetupStatus": zod.enum(['OrganizationRelationshipNeeded', 'NotStarted', 'IdentityVerificationPending', 'PayoutMethodNeeded', 'BankAccountAwaitingReview', 'BankAccountRejected', 'BankAccountUnlinked', 'BankAccountReturned', 'DebitCardNotPayoutEligible', 'DebitCardPayoutsUnavailable', 'Ready']),
  "isPaymentEligible": zod.boolean(),
  "hasApprovedNonPrimaryBankAccount": zod.boolean(),
  "reviewedByUserId": zod.string().uuid().nullish(),
  "reviewerName": zod.string().nullish(),
  "reviewedDate": zod.string().datetime({}).nullish(),
  "reviewNotes": zod.string().nullish(),
  "approvalMethod": zod.enum(['Administrator', 'PreApproved', 'AutoApproved']).optional(),
  "evidence": zod.object({
  "id": zod.string().uuid(),
  "payoutRequestId": zod.string().uuid(),
  "text": zod.string().nullish(),
  "documents": zod.array(zod.object({
  "id": zod.string().uuid(),
  "blobUrlId": zod.string().uuid(),
  "url": zod.string(),
  "hash": zod.string(),
  "contentType": zod.string().nullish(),
  "fileSize": zod.number().nullish(),
  "createdDate": zod.string().datetime({})
})),
  "references": zod.array(zod.object({
  "id": zod.string().uuid(),
  "label": zod.string(),
  "referenceValue": zod.string(),
  "createdDate": zod.string().datetime({})
})),
  "gpsCheckins": zod.array(zod.object({
  "id": zod.string().uuid(),
  "gpsCoordinateId": zod.string().uuid(),
  "latitude": zod.number().nullish(),
  "longitude": zod.number().nullish(),
  "accuracy": zod.number().nullish(),
  "note": zod.string().nullish(),
  "createdDate": zod.string().datetime({})
})),
  "createdDate": zod.string().datetime({}),
  "createdByUserId": zod.string().uuid().nullish()
}).optional(),
  "invoice": zod.object({
  "id": zod.string().uuid(),
  "number": zod.number(),
  "status": zod.enum(['Draft', 'Finalized', 'Paid', 'Voided'])
}).optional(),
  "createdDate": zod.string().datetime({}),
  "modifiedDate": zod.string().datetime({}),
  "createdByUserId": zod.string().uuid().nullish(),
  "modifiedByUserId": zod.string().uuid().nullish(),
  "concurrencyToken": zod.string()
})

